<section class="task-log-diff-section">
  @if (currentSnapshot) {
    <div class="task-log-diff-section__summary">
      <div class="task-log-diff-field">
        <span class="task-log-diff-field__label" i18n>Statut</span>
        <span
          [ngClass]="{
            'new-lead-value': isChanged(
              currentSnapshot.proposalState,
              baselineSnapshot?.proposalState
            ),
          }"
        >
          {{ getProposalStateLabel(currentSnapshot.proposalState) }}
        </span>
        @if (
          baselineSnapshot?.proposalState &&
          isChanged(
            currentSnapshot.proposalState,
            baselineSnapshot?.proposalState
          )
        ) {
          <span class="old-lead-value">{{
            getProposalStateLabel(baselineSnapshot?.proposalState)
          }}</span>
        }
      </div>
    </div>

    <div class="task-log-diff-section__summary">
      <app-task-log-proposal-fields-diff
        [currentSnapshot]="currentSnapshot"
        [baselineSnapshot]="baselineSnapshot"
        [compare]="compare"
        class="w-100"
      />
    </div>
  } @else {
    <div class="text-muted" i18n>Non disponible</div>
  }
</section>
